import React, { useEffect, useState } from "react";
import { IonCol, IonLabel } from "@ionic/react";
import Select from "react-select";

import api from "../../../services/api";

interface Props {
  input: {
    value: any;
    onChange?(e: any): void;
  };
  size?: string;
}

const SearchInput: React.FC<Props> = (props: any) => {
  const [hospitals, setHospitals] = useState([]);

  useEffect(() => {
    searchHospitals();
  }, []);

  function searchHospitals(value?: string | null) {
    api
      .get<any>("search/hospital", { params: { search: value } })
      .then((resp) => {
        setHospitals(resp.data);
      });
  }

  return (
    <IonCol size={props.size || "12"}>
      <IonLabel position="stacked" style={{ color: "#000", fontWeight: 600 }}>
        Hospital
      </IonLabel>
      <Select
        style={{ width: "100%" }}
        placeholder=""
        classNamePrefix="select"
        value={props.input.value ? props.input.value : ""}
        onChange={(value) => {
          if (value) {
            props.input.onChange(value);
          } else {
            props.input.onChange("");
          }
        }}
        onInputChange={(value) => searchHospitals(value)}
        noOptionsMessage={() => "Nenhuma opção"}
        simpleValue
        isDisabled={props.readOnly}
        isClearable={props.isClearable}
        required={props.required}
        options={hospitals}
        styles={{
          menu: (provided) => ({ ...provided, zIndex: 9999 }),
        }}
        components={{
          IndicatorSeparator: () => null,
        }}
      />
    </IonCol>
  );
};

export default SearchInput;
